export default "__VITE_ASSET__C6zFMSj4__"